export default "/template/resource//static/media/img_tianjiashuxing.9f96c888.png";